
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import KaraokeHero from './components/KaraokeHero';
import KaraokeConcept from './components/KaraokeConcept';
import KaraokeServices from './components/KaraokeServices';
import KaraokePricing from './components/KaraokePricing';
import KaraokeNotice from './components/KaraokeNotice';
import KaraokeFaq from './components/KaraokeFaq';
import KaraokeFinalCta from './components/KaraokeFinalCta';
import KaraokeWhatsAppButton from './components/KaraokeWhatsAppButton';

export default function TokyoKaraokeNightPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Tokyo Karaoke Night - 東京カラオケ体験 | 東京ローカルコンシェルジュ';
    document.documentElement.lang = 'ja';

    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', 'No stress. Just fun. 日本のカラオケボックスを地元の友人のように一緒に楽しむ体験。事前予約・機械操作サポート・人気曲紹介で安心。3時間¥18,000〜。WhatsAppで簡単予約。');
    setMeta('keywords', '東京カラオケ,カラオケ体験,訪日外国人,Airbnbゲスト,カラオケボックス,J-Pop,アニメソング,東京ナイトライフ,東京観光,カラオケ予約');
    setMeta('og:title', 'Tokyo Karaoke Night - 東京カラオケ体験 | 東京ローカルコンシェルジュ', true);
    setMeta('og:description', 'No stress. Just fun. 日本のカラオケボックスを地元の友人のように一緒に楽しむ体験。事前予約・機械操作サポート・人気曲紹介で安心。', true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', 'https://tokyolocalconcierge.com/tokyo-karaoke-night', true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', 'Tokyo Karaoke Night - 東京カラオケ体験');
    setMeta('twitter:description', 'No stress. Just fun. 日本のカラオケボックスを地元の友人のように一緒に楽しむ体験。');
    setMeta('geo.region', 'JP-13');
    setMeta('geo.placename', 'Tokyo');
    setMeta('geo.position', '35.6762;139.6503');
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <KaraokeHero lang="ja" />
        <KaraokeConcept lang="ja" />
        <KaraokeServices lang="ja" />
        <KaraokePricing lang="ja" />
        <KaraokeNotice lang="ja" />
        <KaraokeFaq lang="ja" />
        <KaraokeFinalCta lang="ja" />
      </main>
      <Footer />
      <KaraokeWhatsAppButton lang="ja" />
    </div>
  );
}
